module.exports = __webpack_public_path__ + "assets/3c4487face0ba8ee068b3a609191da4d.mp3";